export const isOperatorUser = (roles: string[]): boolean =>
  roles.some((role) => role === 'admin' || role === 'operator')

/**
 * Куда вести после входа по redirect_path из API. Кабинет поставщика и маркетплейс
 * убраны: поставщика ведём в настройки, старые адреса ресторана — в «Мои прайсы».
 */
export const mapApiRedirectPath = (path: string | null | undefined): string => {
  if (!path) {
    return homePathForUser([])
  }
  if (path.startsWith('/operator')) {
    return '/operator'
  }
  if (path.startsWith('/supplier')) {
    return '/settings'
  }
  return '/my-prices'
}

export const homePathForUser = (roles: string[]): string => {
  if (isOperatorUser(roles)) {
    return '/operator'
  }
  const supplierOnly = roles.includes('supplier') && !roles.includes('buyer')
  return supplierOnly ? '/settings' : '/my-prices'
}
